import { useEffect, useRef, type RefObject } from 'react';

import type { ChartLayoutRef } from '../types/chart-layout.js';

/**
 * Hook responsible for re-trigger the automatic ratio calculation on dataset changes
 * @param data -
 *
 * @internal
 */
export const useAutoLegendRefresh = <T,>(
  data?: T,
): RefObject<ChartLayoutRef | null> => {
  const chartLayoutRef = useRef<ChartLayoutRef | null>(null);

  useEffect(() => {
    chartLayoutRef?.current?.refreshLegendSize();
  }, [data]);

  return chartLayoutRef;
};
